import { j as m } from "../../../jsx-runtime.BREq8dyb.js";
import { styled as p, Card as f, Stack as h } from "@mui/joy";
import { memo as x, forwardRef as c, createElement as C, isValidElement as w } from "react";
import j from "./DqCardLabel.js";
const D = p(f, {
  shouldForwardProp: (r) => !["selectable", "compact"].includes(r)
})(({
  theme: {
    palette: r,
    spacing: e,
    radius: t,
    variants: n,
    shadow: d
  },
  selectable: o = !1,
  label: i,
  onClick: a,
  color: s = "neutral",
  compact: l = !1,
  variant: u = "outlined"
}) => ({
  "&.MuiCard-variantOutlined": {
    background: r.common.white
  },
  ...a || o ? {
    "&:hover": {
      boxShadow: d.md,
      cursor: "pointer"
    }
  } : {},
  borderRadius: t.md,
  boxShadow: "none",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: e(0.5),
  position: "relative",
  ...l ? {
    height: "auto",
    // If label is applied in order to prevent its overlapping the content,
    // additional paddingTop needs to be applied
    padding: i ? e(2, 1, 1) : e(1),
    width: "fit-content"
  } : {
    height: "100%",
    padding: e(2)
  }
})), g = x(c(({
  children: r,
  compact: e,
  color: t,
  onClick: n,
  variant: d,
  Actions: o,
  selectable: i,
  label: a,
  ...s
}, l) => /* @__PURE__ */ m.jsxs(D, { color: t, compact: e, label: a, onClick: n, ref: l, selectable: i, variant: d, ...s, children: [
  a && /* @__PURE__ */ m.jsx(j, { color: t, label: a, selectable: i, variant: d }),
  o ? /* @__PURE__ */ m.jsx(h, { ml: "auto", onClick: (u) => u.stopPropagation(), children: w(o) ? o : C(o) }) : null,
  r
] })));
g.displayName = "DqCardBase";
export {
  g as default
};
//# sourceMappingURL=DqCardBase.js.map
